import { useContext } from 'react';
import CustomElementContext from '../contexts/CustomElementContext';

/**
 * Returns the HTML custom element instance containing the current element.
 *
 * This can be used in conjunction with `defineCustomElement()` for
 * components that need more complex interaction with outside consumers via the
 * DOM interface.
 *
 * @return HTMLElement of the current custom element, or null if unavailable.
 */
const useCustomElement = () => useContext(CustomElementContext)?.element;

export default useCustomElement;
